
<div class="ZoomControls">
  <div>
    <div v-bind:class="panToolClass" v-on:click="setPanTool">
      <img src="/img/icons/move-outline.svg" />
      <div class="CircleShadowButton_HoverText m-left">
        <span>Pan (space)</span>
      </div>
    </div>

    <div
      v-if="isZoomAllowed"
      v-on:click="zoomIn"
      :class="{
        CircleShadowButton: true,
        'm-zoom-in': true,
        'm-disabled': !canZoomIn,
      }"
    >
      <img src="/img/icons/add-outline.svg" />
      <div class="CircleShadowButton_HoverText m-left">
        <span>Zoom in</span>
      </div>
    </div>

    <div
      v-if="isZoomAllowed"
      v-on:click="zoomOut"
      :class="{
        CircleShadowButton: true,
        'm-zoom-out': true,
        'm-disabled': !canZoomOut,
      }"
    >
      <img src="/img/icons/remove-outline.svg" />
      <div class="CircleShadowButton_HoverText m-left">
        <span>Zoom out</span>
      </div>
    </div>

    <div
      v-if="isZoomAllowed"
      v-on:click="reset"
      :class="{
        CircleShadowButton: true,
        'm-reset': true,
        'm-disabled': !canReset,
      }"
    >
      <img src="/img/icons/reorder-two-outline.svg" />
      <div class="CircleShadowButton_HoverText m-left">
        <span>Zoom to 100%</span>
      </div>
    </div>
  </div>
</div>
